// This takes an array of countries and gives back an array of numbers that are the indexes
// of any duplicate values found in the original array (unless the value is null)
export function FindDuplicateCountries(array: (string | null)[]): number[] {
  const duplicateIndexes = [];

  array.forEach((value, index) => {
    if (array.indexOf(value) !== index && value !== null) {
      duplicateIndexes.push(index);
    }
  });
  return duplicateIndexes;
}
